/** P2.4-share — pure helpers. No React. Art is drawn in the browser, not on Render. */

export const SHARE_SITE = "https://getmehome.lol";

const PODIUM_CHROME = { 1: "amber", 2: "ruby", 3: "emerald" };

export function shareChrome(rank) {
  return PODIUM_CHROME[Number(rank)] || "standard";
}

export function listingShareUrl(id, origin = SHARE_SITE) {
  const base = String(origin || SHARE_SITE).replace(/\/$/, "");
  return `${base}/#listing-${id}`;
}

export function listingOutboundHref(url) {
  const raw = String(url || "").trim();
  if (!raw) return "";
  const withProto = /^[a-z][a-z0-9+.-]*:/i.test(raw) ? raw : `https://${raw}`;
  try {
    const u = new URL(withProto);
    if (u.protocol !== "http:" && u.protocol !== "https:") return "";
    return u.toString();
  } catch {
    return "";
  }
}

export function tweetIntentUrl({ rank, domain, shareUrl, amount = null } = {}) {
  const rankBit = rank ? ` at #${rank}` : "";
  const who = domain ? ` — ${domain}` : "";
  let text = `I fueled Sam${rankBit} on GetMeHome.lol${who}`;
  if (amount != null && Number.isFinite(amount)) {
    const pct = (amount / 10000) * 100;
    const pctText = pct < 1 ? `${pct.toFixed(2)}%` : `${pct.toFixed(1)}%`;
    text += ` (+${pctText} closer to Earth)`;
  }
  const params = new URLSearchParams();
  params.set("text", text);
  if (shareUrl) params.set("url", shareUrl);
  return `https://twitter.com/intent/tweet?${params.toString()}`;
}

export function readListingDeepLink(hash = "") {
  const m = String(hash || "").match(/^#listing-([A-Za-z0-9_-]+)$/);
  return m ? m[1] : null;
}

export function downloadCanvasPng(canvas, filename = "i-fueled-sam.png") {
  if (!canvas || typeof canvas.toDataURL !== "function") return;
  const a = document.createElement("a");
  a.setAttribute("data-testid", "share-download-link");
  a.download = filename;
  a.href = canvas.toDataURL("image/png");
  a.click();
}
